import { createSelector } from "reselect";
import { get } from "lodash";
export var selectLoginRequesting = function selectLoginRequesting(_ref) {
  var LoginReducer = _ref.LoginReducer;
  return LoginReducer.requesting;
};
export var selectLoginFail = function selectLoginFail(_ref2) {
  var LoginReducer = _ref2.LoginReducer;
  return LoginReducer.failed;
};
export var selectUser = function selectUser(_ref3) {
  var LoginReducer = _ref3.LoginReducer;
  return LoginReducer.profile;
};
export var selectAppUrl = function selectAppUrl(_ref4) {
  var LoginReducer = _ref4.LoginReducer;
  return LoginReducer.appUrl;
};
export var selectUserAgreedToEULA = createSelector([selectUser], function () {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (user === false) {
    return false;
  }

  var agreedToEULA = get(user, "agreed_to_eula") || false;
  return agreedToEULA;
});